import React, { useEffect, useState } from "react";
import TrainerList from "./TrainerList";
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const TrainerAllListLanding = () => {
    const [loginId, setLoginId] = useState('');

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setLoginId(id);
    }, []);

    return (
        <>
            {loginId !== '' ? (
                <>
                    <IdleTimeOutHandler />
                    <TrainerList />
                </>
            ) : (
                <TrainerList />
            )}
        </>
    )
}

export default TrainerAllListLanding;
